module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA0AAAAMCAMAAACOacfrAAAAQlBMVEVHcEz/2AD/0gD/0QD/2AD/1gD/ywD/zgD/0QD/0QD/1gD/1wD/0QD/0wD/ygD/ywD/zAD/ywD/ygD/ygD/2AD/ywAZ0aQJAAAAFHRSTlMA+0EL8pfhJP40sRnyF/ZOZMCveKBmeRAAAABXSURBVAjXRc1XEoAgDEXRUKWMNPP2v1UJ4Hi/OBMIRFK2F/05dj9uxSqfs9GJmZM2csnyLsA/FLcw83OVMHyYVAvlfLKAcvZjt2caGHUAdan1KK97I3oBimoFhbOYIs4AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./static/images/start_level.png
// module id = spAo
// module chunks = 6